import { makeStyles } from '@mui/styles'
const useStyleBreadcrumbs = makeStyles(() => ({
  breadcrumbsStyle: {
    width: '50%',
    display: 'flex',
    marginLeft: '5%',
    marginTop: '2%'
  },
  linkStyle: {
    display: 'flex',
    alignItems: 'center',
    color: '#737373'
  },
  typography: {
    textDecoration: 'underline',
    '&:hover': {
      fontWeight: '700'
    }
  }
}))

export default useStyleBreadcrumbs
